export const REGEX = {
  ROULETTE_PROMO_CODE: /^RLT[A-Z0-9]{4}$/,
};

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;